import React from "react";
import {connect} from "react-redux";
import objectPath from "object-path";
import {version} from "../../../../package"
import {internal_version} from "../../../../package"
import * as builder from "../../ducks/builder";
import {$$} from "../../../helpers/localization";
import {PRIVACY_POLICY_URL, TERMS_OF_USE_URL} from "../../../constants/api_paths";
import PropTypes from "prop-types";
import {localiseURL} from "../../../utils/urlUtils";

class Footer extends React.Component {

    render() {
        const today = new Date().getFullYear()

        let ppUrl = localiseURL(PRIVACY_POLICY_URL);
        let termsUrl = localiseURL(TERMS_OF_USE_URL);

        return (
            <div
                className={`kt-footer ${this.props.footerClasses} kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop`}
                id="kt_footer"
            >
                <div className={`kt-container ${this.props.footerContainerClasses}`}>
                    <div className="kt-footer__copyright text-nowrap">
                        {today.toString()}&nbsp;&copy;&nbsp;
                        Sirma Medical Systems | {$$('version')} {version} ({internal_version})
                    </div>
                    <div className="kt-footer__menu">
                        <a
                            href={termsUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="kt-footer__menu-link kt-link"
                        >
                            {$$('terms_and_conditions')}
                        </a>
                        <a
                            href={ppUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="kt-footer__menu-link kt-link"
                        >
                            {$$('privacy_policy')}
                        </a>
                        <a
                            href="https://www.medrec-m.com/#!/remote"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="kt-footer__menu-link kt-link"
                        >
                            {$$('about')}
                        </a>
                        <a
                            href="https://medrec-m.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="kt-footer__menu-link kt-link"
                        >
                            {$$('contact')}
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => ({
    i18n: store.language,
    fluid:
        objectPath.get(store.builder.layoutConfig, "footer.self.width") === "fluid",
    footerClasses: builder.selectors.getClasses(store, {
        path: "footer",
        toString: true
    }),
    footerContainerClasses: builder.selectors.getClasses(store, {
        path: "footer_container",
        toString: true
    })
});

Footer.propTypes = {
    i18n: PropTypes.object,
    footerContainerClasses: PropTypes.any,
    footerClasses: PropTypes.any
};

export default connect(mapStateToProps)(Footer);
